import io from 'socket.io-client';
import { apiFetch } from './httpClient';

export const config = { iceServers: [], iceTransportPolicy: 'all' };

export async function loadRTCConfiguration() {
    const response = await apiFetch(`${host}/webrtc`);
    const settings = await response.json();
    if (!Array.isArray(settings.iceServers) || !settings.iceServers.length) throw new Error('Нет настроек медиасоединения');
    config.iceServers = settings.iceServers;
    config.iceTransportPolicy = settings.iceTransportPolicy === 'relay' ? 'relay' : 'all';
    return config;
}

export const host = process.env.REACT_APP_BACKEND_HOST === undefined ? "" : process.env.REACT_APP_BACKEND_HOST;
export const socket = io('', { autoConnect: false });
console.log("Front end webRTC: socket connect");
console.log("socket.type: ", socket.type);
console.log("socket: ", socket);

window.addEventListener('pagehide', () => socket.close());
